'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _ValueSet2 = require('../ValueSet');

var _ValueSet3 = _interopRequireDefault(_ValueSet2);

var _cardinality = require('../cardinality');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _ValueSetRegistry = require('../ValueSetRegistry');

var _ValueSetRegistry2 = _interopRequireDefault(_ValueSetRegistry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MultiselectList = function (_ValueSet) {
    (0, _inherits3.default)(MultiselectList, _ValueSet);

    function MultiselectList() {
        (0, _classCallCheck3.default)(this, MultiselectList);
        return (0, _possibleConstructorReturn3.default)(this, (MultiselectList.__proto__ || (0, _getPrototypeOf2.default)(MultiselectList)).apply(this, arguments));
    }

    (0, _createClass3.default)(MultiselectList, [{
        key: 'toQueryFragment',
        value: function toQueryFragment() {
            return this.selectedValues;
        }
    }, {
        key: 'values',
        get: function get() {
            return this.data.values;
        },
        set: function set(value) {
            this.data.values = value;
        }
    }, {
        key: 'selectedValues',
        get: function get() {
            return this.data.selectedValues;
        },
        set: function set(values) {
            this.data.selectedValues = _lodash2.default.intersection(this.values, values);
        }
    }, {
        key: 'dataType',
        get: function get() {
            return this.data.type;
        },
        set: function set(value) {
            this.data.type = value;
        }
    }]);
    return MultiselectList;
}(_ValueSet3.default);

MultiselectList.defaultData = {
    values: [],
    type: 'small_text',
    selectedValues: []
};
MultiselectList.displayName = 'Multiselect List';
MultiselectList.cardinality = _cardinality.cardinalityMany;
MultiselectList.hasDataType = true;
MultiselectList.dataset = false;

_ValueSetRegistry2.default.register(MultiselectList);
exports.default = MultiselectList;